
import { useNavigate } from 'react-router-dom';
import { useTonConnectUI } from '@tonconnect/ui-react';
import {  beginCell, toNano } from '@ton/core';
import BackButton from './BackButton';
import TonWeb from 'tonweb';
import './WalletPage.css';
import React, { useState, useEffect } from 'react';
import { HttpClient, Address, TonClient, WalletContractV4, JettonMaster , external, storeMessage} from "@ton/ton";
import { Cell } from '@ton/core';


const apiKey = 'af367eea985bd0df59ae17d9aa218a1af12ede3bdf4755f4188f7582f5fb3859'; //ключ с бота тг

const client = new TonClient({ endpoint: 'https://toncenter.com/api/v2/jsonRPC', apiKey });



function httpGetAsync(theUrl, callback)
{
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.onreadystatechange = function() { 
        if (xmlHttp.readyState == 4 && xmlHttp.status == 200)
            callback(xmlHttp.responseText);
    }
    xmlHttp.open("GET", theUrl, true); // true for asynchronous 
    xmlHttp.send(null);
}

var address = "";
const Tonkeeper = Address.parse("kQAiboDEv_qRrcEdrYdwbVLNOXBHwShFbtKGbQVJ2OKxY_Di");
const userJettonWallet = Address.parse('EQDNsLrpk_alkeQKeq5OqlAYGGPARWH9WLtyyHJy8Imb9HXt');
const jettonMasterAddress = Address.parse('EQCxE6mUtQJKFnGfaROTKOt1lZbDiiX1kCixRv7Nw2Id_sDs');
const toAddress = Address.parse('UQD2KDv1Ggp2cFg6TOBb1LKm22HMu9bSptKDH5WWEKBimC9n');
const fromAddress = Address.parse('UQCLEJm1wQAvZ8oQJNSPEcxeVm04cscV0MEyBvqHZhTWxfO8');
const ContractjettonWalletAddress = Address.parse('kQCShRY-v3ciLAgbXEuxXpdb185u8Hgq0D8Svgq_Krxl4Ajn');
const jettonAmount = '0.0055009589000000000000'; // например 10 AIOTX (с учётом 9 знаков)
function toJettonAmount(valueStr, decimals) {
    const [intPart, fracPart = ""] = valueStr.split(".");
    const frac = fracPart.padEnd(decimals, "0").slice(0, decimals); // ровно `decimals` знаков
    return intPart + frac;
}
async function sendPaymentDataToBackend(tx_hash, address, toAddress) {
  try {
    const body = {
      order_id: parseInt(localStorage.getItem('orderId') || '0'),
      transaction_id: parseInt(localStorage.getItem('transaction_id') || '0'),
      tx_hash: tx_hash,
      wallet_address: address.toString(),
      wallet_tag: null,
      currency_name: "USDT",
      payment_amount: parseFloat(localStorage.getItem('jettonAmount') || '0'),
      receiver_wallet_address: toAddress.toString(),
      receiver_wallet_tag: null
    };

    const response = await fetch("/api/Orders/Order_SetPaymentData", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("accessToken")
      },
      body: JSON.stringify(body)
    });

    const result = await response.json();
    alert("Ответ от Order_SetPaymentData: " + JSON.stringify(result));
  } catch (error) {
    console.error("Ошибка при отправке Order_SetPaymentData:", error);
    alert("Ошибка при отправке данных оплаты: " + error);
  }
}
async function getUserWalletAddress(userAddress, jettonMasterAddress) {
    const client = new TonClient({
        endpoint: 'https://toncenter.com/api/v2/jsonRPC',
    });
    const userAddressCell = beginCell().storeAddress(userAddress).endCell()
    const response = await client.runMethod(jettonMasterAddress, "get_wallet_address", [
        {type: "slice", cell: userAddressCell}
    ])
    return response.stack.readAddress()
}


const WalletPage = () => {
  const [jettonAmountValue, setJettonAmountValue] = useState(() => localStorage.getItem('jettonAmount') || '0.005');
  const [orderId, setOrderId] = useState(() => localStorage.getItem('orderId') || '0');
  const [token, setToken] = useState(() => localStorage.getItem('accessToken') || '');
  const [transaction_id, setTransaction] = useState(() => localStorage.getItem('transaction_id') || '');
  const saveSettings = () => {
      localStorage.setItem('jettonAmount', jettonAmountValue);
      localStorage.setItem('orderId', orderId);
      localStorage.setItem('accessToken', token);
      localStorage.setItem('transaction_id', transaction_id);
      alert('Данные сохранены!');
  };
  const forwardPayload= beginCell()
        .storeUint(orderId, 64) // 0 opcode means we have a comment
        .endCell();
  const navigate = useNavigate();                 
  const [tonConnectUI] = useTonConnectUI();        
/**
 * Ensure that the user is connected to the wallet. If not, open a modal to
 * connect the wallet. After the wallet is connected, update the address
 * variable with the wallet's address.
 */
  const ensureConnected = async () => {
   
  if (!tonConnectUI.wallet) {
    await tonConnectUI.openModal(); // Откроет окно подключения кошелька
    
    
  }
  address = Address.parse(tonConnectUI.wallet.account.address);
};
  const CancelWallet = async () => {
    await tonConnectUI.disconnect();
  }
  const handlePayment = async () => {
  try {
    await ensureConnected();

    var JetAddress = await getUserWalletAddress(address, jettonMasterAddress);
    //const jettonWalletAddress = await getUserJettonWalletAddress(address, jettonMasterAddress);
    const transaction = {
      validUntil: Math.floor(Date.now() / 1000) + 300,
      messages: [
        {
          address: JetAddress.toString(true, true, true), // 👈 отправляем на него!
          amount: toNano('0.05').toString(),
          payload: beginCell()
                .storeUint(0x0f8a7ea5, 32)   // op
                .storeUint(0, 64)          // query_id
                .storeCoins(toJettonAmount(jettonAmountValue,6)) // jetton amount, amount * 10^9
                .storeAddress(toAddress) // jetton address
                .storeAddress(toAddress) // response destination
                .storeUint(0, 1)             // query_id
                .storeCoins(0) // forward_ton_amount
                .storeUint(1, 1)  
                .storeRef(forwardPayload)
                .endCell().toBoc().toString('base64'),
          bounce: false
        },
      ],
    };

    const transactionPay = {
      validUntil: Math.floor(Date.now() / 1000) + 300,
      messages: [
        {
          address: toAddress.toString(true, true, true), // 👈 отправляем на него!
          amount: toNano('0.06').toString(),
          payload: forwardPayload.toBoc().toString('base64'),
        },
      ],
    };
    const result = await tonConnectUI.sendTransaction(transaction);
    const bocCellBytes = await TonWeb.boc.Cell.oneFromBoc(TonWeb.utils.base64ToBytes(result.boc)).hash();
    const tx_hash = TonWeb.utils.bytesToHex(bocCellBytes);

    await sendPaymentDataToBackend( tx_hash, address, toAddress);
    //const rawSender = `${fromAddress.workChain}:${Buffer.from(fromAddress.hash).toString('hex')}`;
    //const rawRecipient = `${userJettonWallet.workChain}:${Buffer.from(userJettonWallet.hash).toString('hex')}`;
    //const hashHex = TonWeb.utils.bytesToHex(bocCellBytes);
    //const apiUrl = `http://localhost:15276/ton/transaction/${rawSender}/${rawRecipient}/${hashHex}`;

    //console.log('🔗 Проверяю транзакцию:', apiUrl);

    //const resultcheck = await fetch(apiUrl)
    //.then(res => res.json())
    //.then(data => {
      //console.log('Transaction status:', data);
    //})
    //.catch(err => console.error(err));
    //console.log('Signed BOC:', resultcheck);
    //navigate('/success');
  } catch (error) {
    console.error('Ошибка при отправке транзакции:', error);
  }
};
  

  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  return (
    <div className="container">
      {loading ? (
        <div className="loader-container">
            <div className="spinner"></div>
        </div>
      ) : (
    <div className="wallet-page">
      <button onClick={handlePayment} className="pay-button">
        Оплатить
      </button>
      <button onClick={CancelWallet} className="pay-button">
        Сбросить
      </button>
      <BackButton onClick={() => navigate('/fork')} />
      <div className="settings-form">
      <label>Jetton Amount: 
        <input type="text" value={jettonAmountValue} onChange={(e) => setJettonAmountValue(e.target.value)} />
      </label>
      <label>Order ID: 
        <input type="text" value={orderId} onChange={(e) => setOrderId(e.target.value)} />
      </label>
      <label>Access Token: 
        <input type="text" value={token} onChange={(e) => setToken(e.target.value)} />
      </label>
       <label>Transaction ID: 
        <input type="text" value={transaction_id} onChange={(e) => setTransaction(e.target.value)} />
      </label>
      <button onClick={saveSettings}>Сохранить настройки</button>
    </div>
    </div>
    )}
    </div>
  );
};

export default WalletPage;